import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, FileQuestion } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useTranslation } from "@/hooks/useTranslation";
import { ROUTES } from '@/lib/routes';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { translate } = useTranslation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    
    // Check if user is logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsLoggedIn(!!session);
    });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background" role="main">
      <div className="text-center max-w-md mx-auto p-8">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-muted p-4">
            <FileQuestion className="h-12 w-12 text-muted-foreground" />
          </div>
        </div>
        <h1 className="mb-2 text-4xl font-bold text-foreground">404</h1>
        <p className="mb-6 text-xl text-muted-foreground">
          {translate("not_found_message")}
        </p>
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            {translate("not_found_go_back")}
          </Button>
          {isLoggedIn ? (
            <Button onClick={() => navigate(ROUTES.DASHBOARD)}>
              {translate("not_found_go_to_dashboard")}
            </Button>
          ) : (
            <Button onClick={() => navigate(ROUTES.HOME)}>
              <Home className="mr-2 h-4 w-4" />
              {translate("not_found_go_home")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
